import { useState, useEffect } from "react";
import "./style.css";
import api from "../../../services/api.js";
import Modal from "react-modal";
import ModalRecompensa from "react-modal";
import ModalRecompensaProduto from "react-modal";
import ModalMissao from "react-modal";
import ModalColaboradorMissao from "react-modal";
import ModalMissaoRecompensa from "react-modal";
import ModalRecompensaMissaoProduto from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import PopUpRecompensa from "../../../componente/popup/index.jsx";
import PopUpRecompensaLojinha from "../../../componente/popup/index.jsx";
import PopUpMissao from "../../../componente/popup/index.jsx";
import PopUpColaboradorMissao from "../../../componente/popup/index.jsx";
import PopUpRecompensaMissao from "../../../componente/popup/index.jsx";
import PopUpRecompensaMissaoLojinha from "../../../componente/popup/index.jsx";
import { useAppContext } from '../../../context/AppContext.js';
import LoadingScreen from "../../../componente/aguarde/index.jsx";

function CadTitulo() {
  const { DateTime } = require("luxon");
  const [lista, setlista] = useState([]);
  const [abusca, setabusca] = useState("");
  const [showform, setshowform] = useState(false);
  const [loading, setLoading] = useState(false);

  const [edtcodtitulo, setedtcodtitulo] = useState(0);
  const [edttitulo, setedttitulo] = useState("");
  const [edtdescricao, setedtdescricao] = useState("");

  const [novo, setnovo] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  const { codassinante, selectedCompany, accessKey } = useAppContext(); 

  //campos de recompensa titulo
  const [showformrecompensa, setshowformrecompensa] = useState(false);
  const [isOpenRecompensa, setIsOpenRecompensa] = useState(false);
  const [listarecompensa, setlistarecompensa] = useState([]);
  const [edtcodrecompensatitulo, setedtcodrecompensatitulo] = useState(0);
  const [edtdescricaotitulo, setedtdescricaotitulo] = useState("");
  const [edtvalorrealtitulo, setedtvalorrealtitulo] = useState(0);
  const [edtvalorcointitulo, setedtvalorcointitulo] = useState(0);
  const [edttiporecompensatitulo, setedttiporecompensatitulo] = useState("");
  const [edtbeneficiorecompensatitulo, setedtbeneficiorecompensatitulo] = useState("");

  //campos de recompensa titulo lojinha
  const [showformrecompensatitulolojinha, setshowformrecompensatitulolojinha] = useState(false);
  const [isOpenRecompensaTituloLojinha, setisOpenRecompensaTituloLojinha] = useState(false);
  const [listarecompensatitulolojinha, setlistarecompensatitulolojinha] = useState([]);
  const [listaproduto, setlistaproduto] = useState([]);
  const [edtcodrecompensatitulolojinha, setedtcodrecompensatitulolojinha] = useState(0);
  const [edtqtderecompensatitulolojinha, setedtqtderecompensatitulolojinha] = useState(0);
  const [edtcodprodutorecompensatitulolojinha, setedtcodprodutorecompensatitulolojinha] = useState(0);

  //campos de missão
  const [showformmissao, setshowformmissao] = useState(false);
  const [isOpenMissao, setIsOpenMissao] = useState(false);
  const [listamissao, setlistamissao] = useState([]);
  const [edtcodmissao, setedtcodmissao] = useState(0);
  const [edttitulomissao, setedttitulomissao] = useState("");
  const [edtdescricaomissao, setedtdescricaomissao] = useState("");
  const [edtdtlancamentomissao, setedtdtlancamentomissao] = useState("");
  const [edtdtiniciomissao, setedtdtiniciomissao] = useState("");
  const [edtdtterminomissao, setedtdtterminomissao] = useState("");

  //campos dos colaboradores da missão
  const [showformcolaboradormissao, setshowformcolaboradormissao] = useState(false);
  const [isOpenColaboradorMissao, setisOpenColaboradorMissao] = useState(false);
  const [listacolaboradormissao, setlistacolaboradormissao] = useState([]);
  const [listaequipe, setlistaequipe] = useState([]);
  const [listasetor, setlistasetor] = useState([]);
  const [listafuncao, setlistafuncao] = useState([]);
  const [listacolaborador, setlistacolaborador] = useState([]);
  const [edtcodcolaboradormissao, setedtcodcolaboradormissao] = useState(0);
  const [edtcodequipe, setedtcodequipe] = useState(0);
  const [edtcodsetor, setedtcodsetor] = useState(0);
  const [edtcodfuncao, setedtcodfuncao] = useState(0);
  const [edtcodcolaborador, setedtcodcolaborador] = useState(0);

  //campos recompensa missao
  const [showformrecompensamissao, setshowformrecompensamissao] = useState(false);
  const [isOpenRecompensaMissao, setIsOpenRecompensaMissao] = useState(false);
  const [listarecompensamissao, setlistarecompensamissao] = useState([]);
  const [listaevento, setlistaevento] = useState([]);
  const [edtcodrecompensamissao, setedtcodrecompensamissao] = useState(0);
  const [edtdescricaotitulomissao, setedtdescricaotitulomissao] = useState("");
  const [edtvalorrealtitulomissao, setedtvalorrealtitulomissao] = useState(0);
  const [edtvalorcointitulomissao, setedtvalorcointitulomissao] = useState(0);
  const [edtcodeventotitulomissao, setedtcodeventotitulomissao] = useState(0);
  const [edttiporecompensatitulomissao, setedttiporecompensatitulomissao] = useState("");

  //campos de recompensa missao lojinha
  const [showformrecompensamissaolojinha, setshowformrecompensamissaolojinha] = useState(false);
  const [isOpenRecompensaMissaoLojinha, setisOpenRecompensaMissaoLojinha] = useState(false);
  const [listarecompensamissaolojinha, setlistarecompensamissaolojinha] = useState([]);
  const [edtcodrecompensamissaolojinha, setedtcodrecompensamissaolojinha] = useState(0);
  const [edtqtderecompensamissaolojinha, setedtqtderecompensamissaolojinha] = useState(0);
  const [edtcodprodutorecompensamissaolojinha, setedtcodprodutorecompensamissaolojinha] = useState(0);

  const handleOpen = (cad) => {
    setedtcodtitulo(cad.codtitulo);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    Excluir();
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleOpenRecompensa = (cad) => {
    setedtcodrecompensatitulo(cad.codrecompensatitulo);
    setIsOpenRecompensa(true);
  };

  const handleConfirmaRecompensa = () => {
    setIsOpenRecompensa(false);
    ExcluirRecompensa();
  };

  const handleCloseRecompensa = () => {
    setIsOpenRecompensa(false);
  };

  const handleOpenRecompensaTituloLojinha = (cad) => {
    setedtcodrecompensatitulolojinha(cad.codrecompensatitulolojinha);
    setisOpenRecompensaTituloLojinha(true);
  };

  const handleConfirmaRecompensaTituloLojinha = () => {
    setisOpenRecompensaTituloLojinha(false);
    ExcluirRecompensaTituloLojinha();
  };

  const handleCloseRecompensaTituloLojinha = () => {
    setisOpenRecompensaTituloLojinha(false);
  };

  const handleOpenMissao = (cad) => {
    setedtcodmissao(cad.codmissao);
    setIsOpenMissao(true);
  };

  const handleConfirmaMissao = () => {
    setIsOpenMissao(false);
    ExcluirMissao();
  };

  const handleCloseMissao = () => {
    setIsOpenMissao(false);
  };

  const handleOpenColaboradorMissao = (cad) => {
    setedtcodcolaboradormissao(cad.codcolaboradormissao);
    setisOpenColaboradorMissao(true);
  };

  const handleConfirmaColaboradorMissao = () => {
    setisOpenColaboradorMissao(false);
    ExcluirColaboradorMissao();
  };

  const handleCloseColaboradorMissao = () => {
    setisOpenColaboradorMissao(false);
  };

  const handleOpenRecompensaMissao = (cad) => {
    setedtcodrecompensamissao(cad.codrecompensamissao);
    setIsOpenRecompensaMissao(true);
  };

  const handleConfirmaRecompensaMissao = () => {
    setIsOpenRecompensaMissao(false);
    ExcluirRecompensaMissao();
  };

  const handleCloseRecompensaMissao = () => {
    setIsOpenRecompensaMissao(false);
  };

  const handleOpenRecompensaMissaoLojinha = (cad) => {
    setedtcodrecompensamissaolojinha(cad.codrecompensamissaolojinha);
    setisOpenRecompensaMissaoLojinha(true);
  };

  const handleConfirmaRecompensaMissaoLojinha = () => {
    setisOpenRecompensaMissaoLojinha(false);
    ExcluirRecompensaMissaoLojinha();
  };

  const handleCloseRecompensaMissaoLojinha = () => {
    setisOpenRecompensaMissaoLojinha(false);
  };

  function ListarTitulo() {
    api
      .get("v1/cadastro/titulo", {
        params: {
          busca: abusca,
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlista(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(
    function () {
      ListarTitulo();
    },
    [showform, abusca]
  );

  function ListarRecompensa() {
    api
      .get("v1/cadastro/titulo/recompensatitulo", {
        params: {
          busca: "",
          codtitulo: edtcodtitulo
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistarecompensa(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarTituloRecompensaLojinha() {
    api
      .get("v1/cadastro/titulo/recompensatitulo/recompensatitulolojinha", {
        params: {
          busca: "",
          codrecompensatitulo: edtcodrecompensatitulo
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistarecompensatitulolojinha(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarMissao() {
    api
      .get("v1/cadastro/titulo/missao", {
        params: {
          busca: "",
          codtitulo: edtcodtitulo
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistamissao(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarColaboradorMissao() {
    api
      .get("v1/cadastro/titulo/missao/colaboradormissao", {
        params: {
          busca: "",
          codmissao: edtcodmissao
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistacolaboradormissao(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarRecompensaMissao() {
    api
      .get("v1/cadastro/titulo/missao/recompensamissao", {
        params: {
          busca: "",
          codmissao: edtcodmissao
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistarecompensamissao(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarRecompensaMissaoLojinha() {
    api
      .get("v1/cadastro/titulo/missao/recompensamissao/recompensamissaolojinha", {
        params: {
          busca: "",
          codrecompensamissao: edtcodrecompensamissao
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistarecompensamissaolojinha(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarEvento() {
    api
      .get("v1/cadastro/evento", {
        params: {
          busca: "",
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistaevento(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarProduto() {
    api
      .get("v1/cadastro/lojinha", {
        params: {
          busca: "",
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistaproduto(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarEquipe() {

    api
      .get("/v1/cadastro/equipe", {
        params: {
          busca: "",
          codassinante: codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistaequipe(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarSetor() {

    api
      .get("/v1/cadastro/setor", {
        params: {
          busca: "",
          codassinante: codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistasetor(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarFuncao() {
    api
      .get("v1/cadastro/funcao", {
        params: {
          busca: "",
          codassinante: codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistafuncao(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarColaborador() {
    api
      .get("v1/cadastro/colaborador", {
        params: {
          busca: "",
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistacolaborador(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Cadastrar() {
    api
      .post(
        "v1/cadastro/titulo",
        {
          titulo: edttitulo,
          descricao: edtdescricao,
          excluido: "N",
          codassinante,
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarTitulo();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function CadastrarRecompensaTitulo() {
    api
      .post(
        "v1/cadastro/titulo/recompensatitulo",
        {
          descricao: edtdescricaotitulo,
          valorreal: edtvalorrealtitulo,
          valorcoin: edtvalorcointitulo,
          tiporecompensa: edttiporecompensatitulo,
          excluido: "N",
          codtitulo: edtcodtitulo,
          codassinante,
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(function (response) {
        setedtdescricaotitulo("");
        setedttiporecompensatitulo("R");
        setedtvalorrealtitulo(0);
        setedtvalorcointitulo(0);

        setedtcodrecompensatitulo(response.data.codrecompensatitulo);

        if (edtbeneficiorecompensatitulo !== "") {
          api
            .post(
              "v1/cadastro/titulo/recompensatitulo/beneficiotitulo",
              {
                descricao: edtbeneficiorecompensatitulo,
                codrecompensatitulo: response.data.codrecompensatitulo,
                excluido: "N",
                codassinante,
                codempresa: selectedCompany
              },
              {
                headers: {
                  Authorization: `Bearer ${accessKey}`,
                },
              }
            )
            .then(() => {
              setedtbeneficiorecompensatitulo("");
            })
            .catch(function (err) {
              console.log("ops! ocorreu um erro: " + err);
            });
        }

        ListarRecompensa();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function CadastrarRecompensaTituloLojinha() {
    api
      .post(
        "v1/cadastro/titulo/recompensatitulo/recompensatitulolojinha",
        {
          qtde: edtqtderecompensatitulolojinha,
          codproduto: edtcodprodutorecompensatitulolojinha,
          codrecompensatitulo: edtcodrecompensatitulo,
          excluido: "N",
          codassinante,
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        setedtqtderecompensatitulolojinha(0);

        ListarTituloRecompensaLojinha();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function CadastrarRecompensaMissaoLojinha() {
    api
      .post(
        "v1/cadastro/titulo/recompensamissao/recompensamissaolojinha",
        {
          qtde: edtqtderecompensamissaolojinha,
          codproduto: edtcodprodutorecompensamissaolojinha,
          codrecompensamissao: edtcodrecompensamissao,
          excluido: "N",
          codassinante,
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        setedtqtderecompensamissaolojinha(0);

        ListarRecompensaMissaoLojinha();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function CadastrarMissao() {
    api
      .post(
        "v1/cadastro/titulo/missao",
        {
          titulo: edttitulomissao,
          descricao: edtdescricaomissao,
          dtlancamento: edtdtlancamentomissao,
          dtinicio: edtdtiniciomissao,
          dttermino: edtdtterminomissao,
          excluido: "N",
          codtitulo: edtcodtitulo,
          codassinante,
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        setedttitulomissao("");
        setedtdescricaomissao("");

        const dt = new Date();
        const date =
          dt.getFullYear() +
          "-" +
          (dt.getMonth() + 1).toString().padStart(2, "0") +
          "-" +
          dt.getDate().toString().padStart(2, "0");
        let time =
          dt.getHours().toString().padStart(2, "0") +
          ":" +
          dt.getMinutes().toString().padStart(2, "0");
        let dtcadastro = date + "T" + time;

        setedtdtlancamentomissao(dtcadastro);
        setedtdtiniciomissao("");
        setedtdtterminomissao("");

        ListarMissao();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function CadastrarColaboradorMissao0() {
    api
      .post(
        "v1/cadastro/titulo/missao/colaboradormissao/colaboradorequipe",
        {
          codequipe: edtcodequipe,
          codmissao: edtcodmissao,
          codassinante,
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarColaboradorMissao();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function CadastrarColaboradorMissao1() {
    api
      .post(
        "v1/cadastro/titulo/missao/colaboradormissao/colaboradorsetor",
        {
          codsetor: edtcodsetor,
          codmissao: edtcodmissao,
          codassinante,
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarColaboradorMissao();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function CadastrarColaboradorMissao2() {
    api
      .post(
        "v1/cadastro/titulo/missao/colaboradormissao/colaboradorfuncao",
        {
          codfuncao: edtcodfuncao,
          codmissao: edtcodmissao,
          codassinante,
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarColaboradorMissao();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function CadastrarColaboradorMissao3() {
    api
      .post(
        "v1/cadastro/titulo/missao/colaboradormissao",
        {
          codcolaborador: edtcodcolaborador,
          codmissao: edtcodmissao,
          codassinante,
          codempresa: selectedCompany,
          excluido: "N"
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarColaboradorMissao();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function CadastrarRecompensaMissao() {
    api
      .post(
        "v1/cadastro/titulo/missao/recompensamissao",
        {
          descricao: edtdescricaotitulomissao,
          valorreal: edtvalorrealtitulomissao,
          valorcoin: edtvalorcointitulomissao,
          tiporecompensa: edttiporecompensatitulomissao,
          excluido: "N",
          codmissao: edtcodmissao,
          codassinante,
          codempresa: selectedCompany,
          codevento: edtcodeventotitulomissao,
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(function (response) {
        setedtdescricaotitulomissao("");
        setedttiporecompensatitulomissao("R");
        setedtvalorrealtitulomissao(0);
        setedtvalorcointitulomissao(0);

        setedtcodrecompensamissao(response.data.codrecompensamissao);

        ListarRecompensaMissao();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Editar() {
    api
      .put(
        "v1/cadastro/titulo",
        {
          codtitulo: edtcodtitulo,
          titulo: edttitulo,
          descricao: edtdescricao,
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarTitulo();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Excluir() {
    api
      .delete("v1/cadastro/titulo", {
        params: {
          codtitulo: edtcodtitulo,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarTitulo();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ExcluirRecompensa() {
    api
      .delete("v1/cadastro/titulo/recompensatitulo", {
        params: {
          codrecompensatitulo: edtcodrecompensatitulo,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarRecompensa();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ExcluirRecompensaTituloLojinha() {
    api
      .delete("v1/cadastro/titulo/recompensatitulo/recompensatitulolojinha", {
        params: {
          codrecompensatitulolojinha: edtcodrecompensatitulolojinha,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarTituloRecompensaLojinha();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ExcluirMissao() {
    api
      .delete("v1/cadastro/titulo/missao", {
        params: {
          codmissao: edtcodmissao,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarMissao();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ExcluirColaboradorMissao() {
    api
      .delete("v1/cadastro/titulo/missao/colaboradormissao", {
        params: {
          codcolaboradormissao: edtcodcolaboradormissao,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarColaboradorMissao();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ExcluirRecompensaMissao() {
    api
      .delete("v1/cadastro/titulo/missao/recompensamissao", {
        params: {
          codrecompensamissao: edtcodrecompensamissao,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarRecompensaMissao();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ExcluirRecompensaMissaoLojinha() {
    api
      .delete("v1/cadastro/titulo/missao/recompensamissao/recompensamissaolojinha", {
        params: {
          codrecompensamissaolojinha: edtcodrecompensamissaolojinha,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarRecompensaMissaoLojinha();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Salvar() {
    novo ? Cadastrar() : Editar();
    setshowform(false);
  }

  function closeModal() {
    setshowform(false);
  }

  function closeModalRecompensa() {
    setshowformrecompensa(false);
  }

  function closeModalRecompensaLojinha() {
    setshowformrecompensatitulolojinha(false);
  }

  function closeModalMissao() {
    setshowformmissao(false);
  }

  function closeModalColaboradorMissao() {
    setshowformcolaboradormissao(false);
  }

  function closeModalMissaoRecompensa() {
    setshowformrecompensamissao(false);
  }

  function closeModalRecompensaMissaoLojinha() {
    setshowformrecompensamissaolojinha(false);
  }

  function openModalNovo() {
    setshowform(true);
    setnovo(true);

    setedtcodtitulo(0);
    setedttitulo("");
    setedtdescricao("");
  }

  function openModalEditar(cad) {
    setshowform(true);
    setnovo(false);

    setedtcodtitulo(cad.codtitulo);
    setedttitulo(cad.titulo);
    setedtdescricao(cad.descricao);
  }

  function openModalRecompensa() {
    setshowformrecompensa(true);

    setedtdescricaotitulo("");
    setedttiporecompensatitulo("R");
    setedtvalorrealtitulo(0);
    setedtvalorcointitulo(0);

    ListarRecompensa();
  }

  function openModalProdutoRecompensa() {
    setshowformrecompensatitulolojinha(true);

    ListarProduto();
    setedtqtderecompensatitulolojinha(0);

    CadastrarRecompensaTitulo();
  }

  function openModalMissao() {
    setshowformmissao(true);

    setedtcodmissao(0);
    setedttitulomissao("");
    setedtdescricaomissao("");

    const dt = new Date();
    const date =
      dt.getFullYear() +
      "-" +
      (dt.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dt.getDate().toString().padStart(2, "0");
    let time =
      dt.getHours().toString().padStart(2, "0") +
      ":" +
      dt.getMinutes().toString().padStart(2, "0");
    let dtcadastro = date + "T" + time;

    setedtdtlancamentomissao(dtcadastro);
    setedtdtiniciomissao("");
    setedtdtterminomissao("");

    ListarMissao();
  }

  function openModalRecompensaMissao(cad) {
    setshowformrecompensamissao(true);

    setedtcodmissao(cad.codmissao);

    setedtdescricaotitulomissao("");
    setedttiporecompensatitulomissao("R");
    setedtvalorrealtitulomissao(0);
    setedtvalorcointitulomissao(0);

    ListarRecompensaMissao();
    ListarEvento();
  }

  function openModalColaboradoresMissao(cad) {
    setshowformcolaboradormissao(true);

    setedtcodmissao(cad.codmissao);

    ListarEquipe();
    ListarSetor();
    ListarFuncao();
    ListarColaborador();

    ListarColaboradorMissao();
  }

  function openModalProdutoRecompensaMissao() {
    setshowformrecompensamissaolojinha(true);

    ListarProduto();
    setedtqtderecompensamissaolojinha(0);

    CadastrarRecompensaMissao();
  }

  const handleEventoChange = (event) => {
    setedtcodeventotitulomissao(event.target.value); // Armazena "null" para todas as empresas
  };

  const handleProdutoTituloChange = (event) => {
    setedtcodprodutorecompensatitulolojinha(event.target.value); // Armazena "null" para todas as empresas
  };

  const handleProdutoMissaoChange = (event) => {
    setedtcodprodutorecompensamissaolojinha(event.target.value); // Armazena "null" para todas as empresas
  };

  const handleEquipeChange = (event) => {
    setedtcodequipe(event.target.value); // Armazena "null" para todas as empresas
  };

  const handleSetorChange = (event) => {
    setedtcodsetor(event.target.value); // Armazena "null" para todas as empresas
  };

  const handleFuncaoChange = (event) => {
    setedtcodfuncao(event.target.value); // Armazena "null" para todas as empresas
  };

  const handleColaboradorChange = (event) => {
    setedtcodcolaborador(event.target.value); // Armazena "null" para todas as empresas
  };

  function FormataDataHora(props) {
    return props
      ? DateTime.fromISO(props)
        .plus({ hours: 3 })
        .toFormat("dd/MM/yyyy HH:mm:ss")
      : null;
  }

  async function Duplicar(item) {
    try {
      setLoading(true);

      await api.post("/v1/cadastro/titulo/duplicar", {
        codtitulo: item.codtitulo,
      },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },

        });

      alert('Duplicação efetivada');

      ListarTitulo();
    } catch (error) {
      console.error('Erro ao excluir dados:', error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div className="app-container">
        <div className="container-fluid">
          <div>
            <div>
              <PopUp isOpen={isOpen} onClose={handleClose}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir esse registro?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirma}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleClose}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUp>

              <PopUpRecompensa isOpen={isOpenRecompensa} onClose={handleCloseRecompensa}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir essa recompensa do título?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirmaRecompensa}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleCloseRecompensa}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUpRecompensa>

              <PopUpRecompensaLojinha isOpen={isOpenRecompensaTituloLojinha} onClose={handleCloseRecompensaTituloLojinha}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir o produto da recompensa do título?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirmaRecompensaTituloLojinha}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleCloseRecompensaTituloLojinha}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUpRecompensaLojinha>

              <PopUpMissao isOpen={isOpenMissao} onClose={handleCloseMissao}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir essa missão do título?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirmaMissao}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleCloseMissao}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUpMissao>

              <PopUpColaboradorMissao isOpen={isOpenColaboradorMissao} onClose={handleCloseColaboradorMissao}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir esse profissional da missão?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirmaColaboradorMissao}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleCloseColaboradorMissao}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUpColaboradorMissao>

              <PopUpRecompensaMissao isOpen={isOpenRecompensaMissao} onClose={handleCloseRecompensaMissao}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir essa recompensa da missão do título?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirmaRecompensaMissao}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleCloseRecompensaMissao}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUpRecompensaMissao>

              <PopUpRecompensaMissaoLojinha isOpen={isOpenRecompensaMissaoLojinha} onClose={handleCloseRecompensaMissaoLojinha}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir o produto da recompensa da missão do título?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirmaRecompensaMissaoLojinha}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleCloseRecompensaMissaoLojinha}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUpRecompensaMissaoLojinha>
            </div>

            <Modal
              isOpen={showform}
              onRequestClose={closeModal}
              overlayClassName="modal-overlay"
              className="modal-content"
            >
              <div className="container-fluid h-100">
                <div className="row">
                  <h2>Novo Cadastro</h2>
                </div>
                <div className="row">
                  <hr />
                </div>

                <div className="row">
                  <form>
                    <div className="row col-sm-12">
                      <div className="col-sm-5">
                        <label htmlFor="titulo" className="form-label">
                          Título
                        </label>
                        <input
                          type="text"
                          id="titulo"
                          className="form-control"
                          placeholder="Título"
                          value={edttitulo}
                          onChange={(e) => setedttitulo(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-5">
                        <label htmlFor="descricao" className="form-label">
                          Descrição
                        </label>
                        <input
                          type="text"
                          id="descricao"
                          className="form-control"
                          placeholder="Descrição"
                          value={edtdescricao}
                          onChange={(e) => setedtdescricao(e.target.value)}
                        />
                      </div>
                    </div>
                  </form>
                </div>

                <div className="row">
                  <div className="col-6 mt-3 d-flex justify-content-start">
                    <button type="button" className="btn btn-primary me-4" onClick={openModalRecompensa} disabled={novo}>
                      Recompensa
                    </button>
                    <button type="button" className="btn btn-primary me-4" onClick={openModalMissao} disabled={novo}>
                      Missões
                    </button>
                  </div>

                  <div className="col-6 mt-3 d-flex justify-content-end">
                    <button className="btn btn-danger ms-4" onClick={closeModal}>
                      Cancelar
                    </button>
                    <button className="btn btn-success ms-4" onClick={Salvar}>
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
            </Modal>

            <ModalRecompensa
              isOpen={showformrecompensa}
              onRequestClose={closeModalRecompensa}
              overlayClassName="modal-overlay"
              className="modal-content"
            >
              <div className="container-fluid h-100">
                <div className="row">
                  <h2>Recompensas do título: {edttitulo}</h2>
                </div>
                <div className="row">
                  <hr />
                </div>

                <div className="row">
                  <form>
                    <div className="row col-sm-12">
                      <div className="col-sm-5">
                        <label htmlFor="descricao" className="form-label">
                          Descrição
                        </label>
                        <input
                          type="text"
                          id="descricao"
                          className="form-control"
                          placeholder="Descrição"
                          value={edtdescricaotitulo}
                          onChange={(e) => setedtdescricaotitulo(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-3">
                        <label htmlFor="tiporecompensa" className="form-label">
                          Tipo de Recompensa
                        </label>
                        <br />
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            id="tiporecompensa"
                            type="radio"
                            name="tiporecompensa"
                            value="R"
                            onChange={(e) => setedttiporecompensatitulo(e.target.value)}
                            checked={edttiporecompensatitulo === "R"}
                          />
                          <label className="form-check-label">Valor em Real</label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="tiporecompensa"
                            value="C"
                            onChange={(e) => setedttiporecompensatitulo(e.target.value)}
                            checked={edttiporecompensatitulo === "C"}
                          />
                          <label className="form-check-label">Valor em Coin</label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="tiporecompensa"
                            value="P"
                            onChange={(e) => setedttiporecompensatitulo(e.target.value)}
                            checked={edttiporecompensatitulo === "P"}
                          />
                          <label className="form-check-label">Produto</label>
                        </div>
                      </div>
                    </div>

                    <div className="row col-sm-12">
                      <div className="col-sm-3">
                        <label htmlFor="valorreal" className="form-label">
                          Valor em Real
                        </label>
                        <input
                          type="number"
                          id="valorreal"
                          className="form-control"
                          placeholder="Valor em Real"
                          value={edtvalorrealtitulo}
                          onChange={(e) => setedtvalorrealtitulo(e.target.valueAsNumber)}
                          disabled={edttiporecompensatitulo === 'C' || edttiporecompensatitulo === 'P'}
                        />
                      </div>

                      <div className="col-sm-3">
                        <label htmlFor="valorcoin" className="form-label">
                          Valor em Coin
                        </label>
                        <input
                          type="number"
                          id="valorcoin"
                          className="form-control"
                          placeholder="Valor em Coin"
                          value={edtvalorcointitulo}
                          onChange={(e) => setedtvalorcointitulo(e.target.valueAsNumber)}
                          disabled={edttiporecompensatitulo === 'R' || edttiporecompensatitulo === 'P'}
                        />
                      </div>

                      <div className="col-sm-3">
                        <br />
                        <button type="button" className="btn btn-primary" disabled={edttiporecompensatitulo === 'R' || edttiporecompensatitulo === 'C'}
                          onClick={openModalProdutoRecompensa}>
                          Adicionar Produto
                        </button>
                      </div>
                    </div>

                    <div className="row col-sm-12">
                      <div className="col-sm-5">
                        <label htmlFor="beneficio" className="form-label">
                          Benefício
                        </label>
                        <input
                          type="text"
                          id="beneficio"
                          className="form-control"
                          placeholder="Benefício"
                          value={edtbeneficiorecompensatitulo}
                          onChange={(e) => setedtbeneficiorecompensatitulo(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-3">
                        <br />
                        <button type="button" className="btn btn-primary" onClick={CadastrarRecompensaTitulo}>
                          Adicionar Recompesa
                        </button>
                      </div>

                    </div>
                  </form>
                </div>

                <div className="row">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Descrição</th>
                        <th>Tipo Recompensa</th>
                        <th>Real</th>
                        <th>Coin</th>
                        <th>Produtos</th>
                        <th>Benefício</th>
                        <th className="acao">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listarecompensa.map(function (item) {
                        return (
                          <tr key={item.codrecompensatitulo}>
                            <th>{item.descricao}</th>
                            <th>{item.tiporecompensa}</th>
                            <th>{item.valorreal}</th>
                            <th>{item.valorcoin}</th>
                            <th>{item.produtos}</th>
                            <th>{item.beneficio}</th>
                            <th>
                              <div className="d-flex justify-content-center">
                                <button
                                  className="btn fa-solid fa-trash"
                                  onClick={() => handleOpenRecompensa(item)}
                                ></button>
                              </div>
                            </th>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colSpan={7}>Quantidade de Registros: {listarecompensa.length}</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button type="button" className="btn btn-danger ms-4" onClick={closeModalRecompensa}>
                      Fechar
                    </button>
                  </div>
                </div>
              </div>
            </ModalRecompensa>

            <ModalRecompensaProduto
              isOpen={showformrecompensatitulolojinha}
              onRequestClose={closeModalRecompensaLojinha}
              overlayClassName="modal-overlay"
              className="modal-content"
            >
              <div className="container-fluid h-100">
                <div className="row">
                  <h2>Produtos da recompensa: {edtdescricaotitulo}</h2>
                </div>
                <div className="row">
                  <hr />
                </div>

                <div className="row">
                  <form>
                    <div className="row col-sm-12">
                      <div className="col-sm-5">
                        <label htmlFor="descricao" className="form-label">
                          Produto
                        </label>
                        <select className="form-select" value={edtcodprodutorecompensatitulolojinha || '0'} onChange={handleProdutoTituloChange}>
                          <option value="0">Selecione o produto</option>
                          {listaproduto.map((pro, index) => (
                            <option key={index} value={pro.codproduto}>{pro.descricao}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-sm-3">
                        <label htmlFor="qtde" className="form-label">
                          Qtde
                        </label>
                        <input
                          type="number"
                          id="qtde"
                          className="form-control"
                          placeholder="Qtde"
                          value={edtqtderecompensatitulolojinha}
                          onChange={(e) => setedtqtderecompensatitulolojinha(e.target.valueAsNumber)}
                        />
                      </div>

                      <div className="col-sm-3">
                        <br />
                        <button type="button" className="btn btn-primary" onClick={CadastrarRecompensaTituloLojinha}>
                          Adicionar Produto
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="row">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Produto</th>
                        <th>Qtde</th>
                        <th className="acao">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listarecompensatitulolojinha.map(function (item) {
                        return (
                          <tr key={item.codrecompensatitulolojinha}>
                            <th>{item.produto}</th>
                            <th>{item.qtde}</th>
                            <th>
                              <div className="d-flex justify-content-center">
                                <button
                                  className="btn fa-solid fa-trash"
                                  onClick={() => handleOpenRecompensaTituloLojinha(item)}
                                ></button>
                              </div>
                            </th>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colSpan={3}>Quantidade de Registros: {listarecompensatitulolojinha.length}</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button type="button" className="btn btn-danger ms-4" onClick={closeModalRecompensaLojinha}>
                      Fechar
                    </button>
                  </div>
                </div>
              </div>
            </ModalRecompensaProduto>

            <ModalMissao
              isOpen={showformmissao}
              onRequestClose={closeModalMissao}
              overlayClassName="modal-overlay"
              className="modal-content"
            >
              <div className="container-fluid h-100">
                <div className="row">
                  <h2>Missões do título: {edttitulo}</h2>
                </div>
                <div className="row">
                  <hr />
                </div>

                <div className="row">
                  <form>
                    <div className="row col-sm-12">
                      <div className="col-sm-5">
                        <label htmlFor="titulo" className="form-label">
                          Título
                        </label>
                        <input
                          type="text"
                          id="titulo"
                          className="form-control"
                          placeholder="Título"
                          value={edttitulomissao}
                          onChange={(e) => setedttitulomissao(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-5">
                        <label htmlFor="descricao" className="form-label">
                          Descrição
                        </label>
                        <input
                          type="text"
                          id="descricao"
                          className="form-control"
                          placeholder="Descrição"
                          value={edtdescricaomissao}
                          onChange={(e) => setedtdescricaomissao(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="row col-sm-12">
                      <div className="col-sm-3">
                        <label htmlFor="dtlancamento" className="form-label">
                          Dt. Lançamento
                        </label>
                        <input
                          type="datetime-local"
                          id="dtlancamento"
                          className="form-control"
                          placeholder="Dt. Lançamento"
                          value={edtdtlancamentomissao}
                          disabled
                        />
                      </div>

                      <div className="col-sm-3">
                        <label htmlFor="dtinicio" className="form-label">
                          Dt. Início
                        </label>
                        <input
                          type="datetime-local"
                          id="dtinicio"
                          className="form-control"
                          placeholder="Dt. Início"
                          value={edtdtiniciomissao}
                          onChange={(e) => setedtdtiniciomissao(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-3">
                        <label htmlFor="dttermino" className="form-label">
                          Dt. Término
                        </label>
                        <input
                          type="datetime-local"
                          id="dttermino"
                          className="form-control"
                          placeholder="Dt. Término"
                          value={edtdtterminomissao}
                          onChange={(e) => setedtdtterminomissao(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-3">
                        <br />
                        <button type="button" className="btn btn-primary" onClick={CadastrarMissao}>
                          Adicionar Missão
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="row">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Título</th>
                        <th>Descrição</th>
                        <th>Dt. Lançamento</th>
                        <th>Dt. Início</th>
                        <th>Dt. Término</th>
                        <th className="acao">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listamissao.map(function (item) {
                        return (
                          <tr key={item.codmissao}>
                            <th>{item.titulo}</th>
                            <th>{item.descricao}</th>
                            <th>{FormataDataHora(item.dtlancamento)}</th>
                            <th>{FormataDataHora(item.dtinicio)}</th>
                            <th>{FormataDataHora(item.dttermino)}</th>
                            <th>
                              <div className="d-flex justify-content-center">
                                <div className="tooltip-container">
                                  <button
                                    className="btn fa-solid fa-user"
                                    onClick={() => openModalColaboradoresMissao(item)}
                                  ></button>
                                  <span className="tooltip-text">Informar colaboradores</span>
                                </div>
                                <div className="tooltip-container">
                                  <button
                                    className="btn fa-solid fa-money-bill"
                                    onClick={() => openModalRecompensaMissao(item)}
                                  ></button>
                                  <span className="tooltip-text">Informar as recompensas</span>
                                </div>
                                <div className="tooltip-container">
                                  <button
                                    className="btn fa-solid fa-trash"
                                    onClick={() => handleOpenMissao(item)}
                                  ></button>
                                  <span className="tooltip-text">Excluir missão</span>
                                </div>
                              </div>
                            </th>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colSpan={6}>Quantidade de Registros: {listamissao.length}</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button className="btn btn-danger ms-4" onClick={closeModalMissao}>
                      Fechar
                    </button>
                  </div>
                </div>
              </div>
            </ModalMissao>

            <ModalColaboradorMissao
              isOpen={showformcolaboradormissao}
              onRequestClose={closeModalColaboradorMissao}
              overlayClassName="modal-overlay"
              className="modal-content"
            >
              <div className="container-fluid h-100">
                <div className="row">
                  <h2>Profissionais da missão: {edtdescricaomissao}</h2>
                </div>
                <div className="row">
                  <hr />
                </div>

                <div className="row">
                  <form>
                    <div className="row">
                      <div className="col-sm-8">
                        <label htmlFor="titulo" className="form-label">
                          Equipe
                        </label>
                        <select className="form-select" value={edtcodequipe || '0'} onChange={handleEquipeChange}>
                          <option value="0">Selecione a equipe</option>
                          {listaequipe.map((eq, index) => (
                            <option key={index} value={eq.codequipe}>{eq.descricao}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-sm-4">
                        <button type="button" className="btn btn-primary h-100 w-100" onClick={CadastrarColaboradorMissao0}>
                          Adicionar Profissionais da equipe
                        </button>
                      </div>
                    </div>

                    <br />

                    <div className="row">
                      <hr />
                    </div>

                    <div className="row">
                      <div className="col-sm-8">
                        <label htmlFor="titulo" className="form-label">
                          Setor
                        </label>
                        <select className="form-select" value={edtcodsetor || '0'} onChange={handleSetorChange}>
                          <option value="0">Selecione o setor</option>
                          {listasetor.map((set, index) => (
                            <option key={index} value={set.codsetor}>{set.descricao}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-sm-4">
                        <button type="button" className="btn btn-primary h-100 w-100" onClick={CadastrarColaboradorMissao1}>
                          Adicionar Profissionais do Setor
                        </button>
                      </div>
                    </div>

                    <br />

                    <div className="row">
                      <hr />
                    </div>

                    <div className="row">
                      <div className="col-sm-8">
                        <label htmlFor="titulo" className="form-label">
                          Função
                        </label>
                        <select className="form-select" value={edtcodfuncao || '0'} onChange={handleFuncaoChange}>
                          <option value="0">Selecione a função</option>
                          {listafuncao.map((fun, index) => (
                            <option key={index} value={fun.codfuncao}>{fun.descricao}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-sm-4">
                        <button type="button" className="btn btn-primary h-100 w-100" onClick={CadastrarColaboradorMissao2}>
                          Adicionar Profissionais da Função
                        </button>
                      </div>
                    </div>

                    <br />

                    <div className="row">
                      <hr />
                    </div>

                    <div className="row col-sm-12">
                      <div className="col-sm-8">
                        <label htmlFor="titulo" className="form-label">
                          Profissional
                        </label>
                        <select className="form-select" value={edtcodcolaborador || '0'} onChange={handleColaboradorChange}>
                          <option value="0">Selecione o profissional</option>
                          {listacolaborador.map((col, index) => (
                            <option key={index} value={col.codcolaborador}>{col.nome}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-sm-4">

                        <button type="button" className="btn btn-primary h-100 w-100" onClick={CadastrarColaboradorMissao3}>
                          Adicionar Profissional
                        </button>
                      </div>
                    </div>

                    <br />
                    <div className="row">
                      <hr />
                    </div>
                  </form>
                </div>

                <div className="row">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Profissional</th>
                        <th>Aceito</th>
                        <th>Concluído</th>
                        <th className="acao">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listacolaboradormissao.map(function (item) {
                        return (
                          <tr key={item.codcolaboradormissao}>
                            <th>{item.colaborador}</th>
                            <th>{item.aceito}</th>
                            <th>{item.concluiu}</th>
                            <th>
                              <div className="d-flex justify-content-center">
                                <button
                                  className="btn fa-solid fa-trash"
                                  onClick={() => handleOpenColaboradorMissao(item)}
                                ></button>
                              </div>
                            </th>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colSpan={4}>Quantidade de Registros: {listacolaboradormissao.length}</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button className="btn btn-danger ms-4" onClick={closeModalColaboradorMissao}>
                      Fechar
                    </button>
                  </div>
                </div>
              </div>
            </ModalColaboradorMissao>

            <ModalMissaoRecompensa
              isOpen={showformrecompensamissao}
              onRequestClose={closeModalMissaoRecompensa}
              overlayClassName="modal-overlay"
              className="modal-content"
            >
              <div className="container-fluid h-100">
                <div className="row">
                  <h2>Recompensas da Missão: {edttitulomissao}</h2>
                </div>
                <div className="row">
                  <hr />
                </div>

                <div className="row">
                  <form>
                    <div className="row col-sm-12">
                      <div className="col-sm-5">
                        <label htmlFor="descricao" className="form-label">
                          Descrição
                        </label>
                        <input
                          type="text"
                          id="descricao"
                          className="form-control"
                          placeholder="Descrição"
                          value={edtdescricaotitulomissao}
                          onChange={(e) => setedtdescricaotitulomissao(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-4">
                        <label htmlFor="evento" className="form-label">
                          Evento
                        </label>
                        <select className="form-select" value={edtcodeventotitulomissao || '0'} onChange={handleEventoChange}>
                          <option value="0">Selecione o evento</option>
                          {listaevento.map((eve, index) => (
                            <option key={index} value={eve.codevento}>{eve.descricao}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-sm-3">
                        <label htmlFor="tiporecompensa" className="form-label">
                          Tipo de Recompensa
                        </label>
                        <br />
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            id="tiporecompensa"
                            type="radio"
                            name="tiporecompensa"
                            value="R"
                            onChange={(e) => setedttiporecompensatitulomissao(e.target.value)}
                            checked={edttiporecompensatitulomissao === "R"}
                          />
                          <label className="form-check-label">Valor em Real</label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="tiporecompensa"
                            value="C"
                            onChange={(e) => setedttiporecompensatitulomissao(e.target.value)}
                            checked={edttiporecompensatitulomissao === "C"}
                          />
                          <label className="form-check-label">Valor em Coin</label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="tiporecompensa"
                            value="P"
                            onChange={(e) => setedttiporecompensatitulomissao(e.target.value)}
                            checked={edttiporecompensatitulomissao === "P"}
                          />
                          <label className="form-check-label">Produto</label>
                        </div>
                      </div>
                    </div>

                    <div className="row col-sm-12">
                      <div className="col-sm-3">
                        <label htmlFor="valorreal" className="form-label">
                          Valor em Real
                        </label>
                        <input
                          type="number"
                          id="valorreal"
                          className="form-control"
                          placeholder="Valor em Real"
                          value={edtvalorrealtitulomissao}
                          onChange={(e) => setedtvalorrealtitulomissao(e.target.valueAsNumber)}
                          disabled={edttiporecompensatitulomissao === 'C' || edttiporecompensatitulomissao === 'P'}
                        />
                      </div>

                      <div className="col-sm-3">
                        <label htmlFor="valorcoin" className="form-label">
                          Valor em Coin
                        </label>
                        <input
                          type="number"
                          id="valorcoin"
                          className="form-control"
                          placeholder="Valor em Coin"
                          value={edtvalorcointitulomissao}
                          onChange={(e) => setedtvalorcointitulomissao(e.target.valueAsNumber)}
                          disabled={edttiporecompensatitulomissao === 'R' || edttiporecompensatitulomissao === 'P'}
                        />
                      </div>

                      <div className="col-sm-3">
                        <br />
                        <button type="button" className="btn btn-primary" disabled={edttiporecompensatitulomissao === 'R' || edttiporecompensatitulomissao === 'C'}
                          onClick={openModalProdutoRecompensaMissao}>
                          Adicionar Produto
                        </button>
                      </div>

                      <div className="col-sm-3">
                        <br />
                        <button type="button" className="btn btn-primary" onClick={CadastrarRecompensaMissao}>
                          Adicionar Recompesa
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="row">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Descrição</th>
                        <th>Tipo Recompensa</th>
                        <th>Real</th>
                        <th>Coin</th>
                        <th>Produtos</th>
                        <th className="acao">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listarecompensamissao.map(function (item) {
                        return (
                          <tr key={item.codrecompensamissao}>
                            <th>{item.descricao}</th>
                            <th>{item.tiporecompensa}</th>
                            <th>{item.valorreal}</th>
                            <th>{item.valorcoin}</th>
                            <th>{item.produtos}</th>
                            <th>
                              <div className="d-flex justify-content-center">
                                <button
                                  className="btn fa-solid fa-trash"
                                  onClick={() => handleOpenRecompensaMissao(item)}
                                ></button>
                              </div>
                            </th>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colSpan={6}>Quantidade de Registros: {listarecompensamissao.length}</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button type="button" className="btn btn-danger ms-4" onClick={closeModalMissaoRecompensa}>
                      Fechar
                    </button>
                  </div>
                </div>
              </div>
            </ModalMissaoRecompensa>

            <ModalRecompensaMissaoProduto
              isOpen={showformrecompensamissaolojinha}
              onRequestClose={closeModalRecompensaMissaoLojinha}
              overlayClassName="modal-overlay"
              className="modal-content"
            >
              <div className="container-fluid h-100">
                <div className="row">
                  <h2>Produtos da recompensa da missao: {edtdescricaotitulomissao}</h2>
                </div>
                <div className="row">
                  <hr />
                </div>

                <div className="row">
                  <form>
                    <div className="row col-sm-12">
                      <div className="col-sm-5">
                        <label htmlFor="descricao" className="form-label">
                          Produto
                        </label>
                        <select className="form-select" value={edtcodprodutorecompensamissaolojinha || '0'} onChange={handleProdutoMissaoChange}>
                          <option value="0">Selecione o produto</option>
                          {listaproduto.map((pro, index) => (
                            <option key={index} value={pro.codproduto}>{pro.descricao}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-sm-3">
                        <label htmlFor="qtde" className="form-label">
                          Qtde
                        </label>
                        <input
                          type="number"
                          id="qtde"
                          className="form-control"
                          placeholder="Qtde"
                          value={edtqtderecompensamissaolojinha}
                          onChange={(e) => setedtqtderecompensamissaolojinha(e.target.valueAsNumber)}
                        />
                      </div>

                      <div className="col-sm-3">
                        <br />
                        <button type="button" className="btn btn-primary" onClick={CadastrarRecompensaMissaoLojinha}>
                          Adicionar Produto
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="row">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Produto</th>
                        <th>Qtde</th>
                        <th className="acao">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listarecompensamissaolojinha.map(function (item) {
                        return (
                          <tr key={item.codrecompensamissaolojinha}>
                            <th>{item.produto}</th>
                            <th>{item.qtde}</th>
                            <th>
                              <div className="d-flex justify-content-center">
                                <button
                                  className="btn fa-solid fa-trash"
                                  onClick={() => handleOpenRecompensaMissaoLojinha(item)}
                                ></button>
                              </div>
                            </th>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colSpan={3}>Quantidade de Registros: {listarecompensamissaolojinha.length}</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button type="button" className="btn btn-danger ms-4" onClick={closeModalRecompensaMissaoLojinha}>
                      Fechar
                    </button>
                  </div>
                </div>
              </div>
            </ModalRecompensaMissaoProduto>
          </div>

          {loading && <LoadingScreen />}

          <div className="row">
            <h1 className="ms-4">Cadastro de Prêmio</h1>
            <p className="ms-4">Rotina para cadastrar os Prêmios que os profissionais irão receber</p>
            <hr />
          </div>

          <div className="row">
            <div className="col-10">
              <label className="d-block" htmlFor="busca">
                Busque aqui
              </label>
              <input
                type="text"
                placeholder="Buscar por: Código ou descrição"
                name="busca"
                id="busca"
                className="form-control me-3"
                value={abusca}
                onChange={(e) => setabusca(e.target.value)}
              />
            </div>
            <div className="col-2 d-flex justify-content-center">
              <button
                className="btn btn-success btnnovo"
                onClick={() => openModalNovo()}
              >
                Novo
              </button>
            </div>
          </div>

          <div className="row mt-3">
            <hr />
          </div>

          <div className="row">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Título</th>
                  <th>Descrição</th>
                  <th className="acao">Ações</th>
                </tr>
              </thead>
              <tbody>
                {lista.map(function (item) {
                  return (
                    <tr key={item.codtitulo}>
                      <th>{item.codtitulo}</th>
                      <th>{item.titulo}</th>
                      <th>{item.descricao}</th>
                      <th>
                        <div className="d-flex justify-content-center">
                          <button
                            className="btn fa-regular fa-pen-to-square"
                            onClick={() => openModalEditar(item)}
                          ></button>
                          <button
                            className="btn fa-solid fa-trash"
                            onClick={() => handleOpen(item)}
                          ></button>
                          <button
                            className="btn fa-solid fa-clone"
                            onClick={() => Duplicar(item)}
                          ></button>
                        </div>
                      </th>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan={5}>Quantidade de Registros: {lista.length}</th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default CadTitulo;
